import React, { Component } from "react";
import IPSDataService from "../services/ips.service";
import countryList from 'react-select-country-list';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import ReactTooltip from 'react-tooltip';
// import moment from "moment";
import Chart from 'react-google-charts';
import { Modal, } from "react-bootstrap";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';


export default class Home extends Component {
   
    constructor(props) {
      super(props);
      this.onChangeSelectedLifeCycleState = this.onChangeSelectedLifeCycleState.bind(this);
      this.onChangeSelectedCapitalSafety = this.onChangeSelectedCapitalSafety.bind(this);
      this.onChangeSelectedRiskPreference = this.onChangeSelectedRiskPreference.bind(this);
      this.onChangeSelectedProductPreference = this.onChangeSelectedProductPreference.bind(this);
      this.onChangeEmail = this.onChangeEmail.bind(this);
      this.onChangeFirstName = this.onChangeFirstName.bind(this);
      this.onChangeContact = this.onChangeContact.bind(this);
      this.onChangeLastName = this.onChangeLastName.bind(this);
      this.onChangePassword = this.onChangePassword.bind(this);
      this.onChangeRePassword = this.onChangeRePassword.bind(this);
      this.options = countryList().getData();

      //  var date= moment().format("YYYY-MM-DD");
      this.state = {
         _100DollarChart : [
            ["Year",  "Rate"],
            ["2013",  400],
            ["2014",  460],
            ["2015",  1120],
            ["2016",  540],
          ],
          
        id: null,
        email:"",
        contact:"",
        fname:"",
        lname:"",
        password:"",
        repassword: "",
        submitted: false,
        captchacheck:false,
        operator:'',
        reloadbtn:true,
        showModal: false,
        message:'',
        Primaryoption1:0,
        Primaryoption4:0,
        dataFillingMessageError:'Error: Please Select portfolio size in section 5',
        portfolioSizeCheck: 0,
        dataFillingMessageSuccess:'',
        TypesOfQuestionaresList:'Loading options',
        sectionQuestions1_0:[],
        sectionQuestions1_1:[],
        sectionQuestions1_2:[],
        sectionQuestions1_3:[],
        sectionQuestions1_4:[],
        sectionQuestions1_5:[],
        sectionQuestions1_6:[],
        sectionQuestions1_7:[],
        sectionQuestions1_8:[],
        sectionQuestions1_9:[],
        sectionQuestions2_1:[],
        LifeCycleState : [ ],
        sectionQuestions2_1_Sliders:[[{ value: 5, label: 'Safety of investment capital is the only concern'},{ value: 10, label: 'Safety of investment principal is primary concern'},{ value: 15, label: 'Increase the portfolio value at moderate rate'},{ value: 20, label: 'Increase the portfolio value quickly with higher risk'}],
                                     [{ value: 5, label: 'Have a relative level' },{ value: 10, label: 'Slightly Increase' },{ value: 15, label: 'Pursue moderate' },{ value: 20, label: 'Pursue investment' },{ value: 25, label: 'Seek maximum' }],
                                     [{ value: 5, label: 'High liquidity money market instrument' },{ value: 10, label: 'Yielding real state with regular divient' },{ value: 15, label: 'Well known compeny with pontiental for continoued growth' },{ value: 20, label: 'Start up that may grow in next 5-7 years' }]
                                    ],
         PreliminaryRiskAssessmentChart: [],
         SelectedLifeCycleState:0,
         SelectedCapitalSafety:0,
         SelectedRiskPreference:0,
         SelectedProductPreference:0,
         SelectedQuestionareType:0,
         CalculatedModelType:'',
         CalculatedModelTypeValues:[],
         Custom_Model:'',
         Custom_ModelArray:[],
         CustomModelChart: [],
         _ALL_Models:[],
         ALL_MODEL_DETAILS_Array:[]
      };
    }

     componentDidMount() 
    {  
        this.retrieveTypesOfQuestionares();
         
    }
    
      closeModal()
      {
         this.setState({
         showModal: false,
         message:""
         });
         
      }

   closeModalAndGoBack()
   {
      this.setState({
      showModal: false,
      message:""
      });
      document.getElementById('go-back-slider').click();
      
   }
  
   openModal()
   {
         this.setState({
         showModal: true,
         message:""
         });
   }
  
   actionModal()
   {
   }

   actionModalSubmit()
   {
      this.saveAccount();
   }

   onChangeEmail(e) 
   {
     this.setState({
       email: e.target.value
     });
   }

   onChangeFirstName(e)
    {
     this.setState({
       fname: e.target.value
     });
   }

   onChangeContact(e) 
   {
      this.setState({
         contact: e.target.value
      });
    }

   onChangeLastName(e) 
   {
     this.setState({
       lname: e.target.value
     });
   }
 
   onChangePassword(e)
    {
     this.setState({
       password: e.target.value
     });
   }
 
   onChangeRePassword(e) 
   {
     this.setState({
       repassword: e.target.value
     });
   }

   // //////////////////////////
// huda


printDocument(Divid) {
  
   const input = document.getElementById(Divid);
   html2canvas(input)
     .then((canvas) => {
       let imgWidth = 208;
       let imgHeight = canvas.height * imgWidth / canvas.width;
       const imgData = canvas.toDataURL('img/png');
       const pdf = new jsPDF('p', 'mm', 'a4');
       pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
       
       pdf.save("download.pdf");
     })
   ;
 }

   // ///////////////////


   saveAccount()
    {
   
      document.getElementById("biosuccessMessage").innerHTML= '';
      document.getElementById("bioerrorMessage").innerHTML= '';
      const _AllQuestionsArray=[];
      _AllQuestionsArray.push(this.state.sectionQuestions1_1);
      _AllQuestionsArray.push(this.state.sectionQuestions1_2);
      _AllQuestionsArray.push(this.state.sectionQuestions1_3);
      _AllQuestionsArray.push(this.state.sectionQuestions1_4);
      _AllQuestionsArray.push(this.state.sectionQuestions1_5);
      _AllQuestionsArray.push(this.state.sectionQuestions1_6);
      _AllQuestionsArray.push(this.state.sectionQuestions1_7);
      _AllQuestionsArray.push(this.state.sectionQuestions1_8);
      _AllQuestionsArray.push(this.state.sectionQuestions1_9);
      _AllQuestionsArray.push(this.state.sectionQuestions2_1);

      var data = {
         email: this.state.email,
         fname: this.state.fname,
         contact: this.state.contact,
         lname: this.state.lname,
         QuestionareTypeID : this.state.SelectedQuestionareType , 
         _AllQuestionsArray:  _AllQuestionsArray , 
      };
      console.log("_______________________________");
      console.log(data);
      console.log("_______________________________");
      const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if(this.state.email!=="")
      {
         if (reg.test(this.state.email) === false){
               
               document.getElementById("bioerrorMessage").innerHTML= "Invalid email address.";
               return false;
         }

      }
      IPSDataService.signup(data)
         .then(response => 
            {
               this.setState({
               submitted: true
               });
               document.getElementById("biosuccessMessage").innerHTML= 'Details has been saved.';
               console.log(response.data);
             })

         .catch(e => 
            {
               document.getElementById("bioerrorMessage").innerHTML= e.response.data.message+"Please provide valid data";
               console.log(e);
             });
      }

    fillStateOfLife()
    {  
       this.state.sectionQuestions1_2.map((List, index)=>(
         List.optionsDetails.map((optionsList, optionIndex)=>(
        
         this.setState(({
            LifeCycleState: [...this.state.LifeCycleState, { value: ((this.LifeCycleStateMapping(optionsList.OptionScoreValue))), label: optionsList.OptionText}]
          }))
         
         ))
       ))
    }

    LifeCycleStateMapping(input)
    {
      if(input===3)
      return 25;
      else if(input===2.5)
      return 45;
      else if(input===2)
      return 55;
      else if(input===1.5)
      return 65;
      else if(input===1.25)
      return 75;
      else if(input===1)
      return 85;
      else
      return 85;
    }


         onChangeSelectedLifeCycleState(sectionQuestions1_2, e) 
         {
            this.setState({
               submitted: false
             });
                     let _AllScores=[];
                     let _ALL_Options=[]
            for(let count=0; count<sectionQuestions1_2[0].optionsDetails.length; count++)
            {
               _ALL_Options.push(sectionQuestions1_2[0].optionsDetails[count]);
               _AllScores.push(sectionQuestions1_2[0].optionsDetails[count].OptionScoreValue);
            }
            console.log(sectionQuestions1_2[0].SectionID );

            let _idsAll=[];
            for (let mj = 0; mj < _AllScores.length; mj++) {
               var str1 = sectionQuestions1_2[0].SectionID.concat('1').concat(String(mj));
               _idsAll.push(str1);
            }
          
                     if(e.target.value>=25 && e.target.value<=45)
                     {
                        sectionQuestions1_2[0].givenAnswer=[];
                        sectionQuestions1_2[0].givenAnswer.push(_ALL_Options[0]);
                        sectionQuestions1_2[0].total_score= parseFloat(_AllScores[0]);
                        document.getElementById(_idsAll[0]).checked = true;
                  }

                  else if(e.target.value>=46 && e.target.value<=55)
                  {
                     sectionQuestions1_2[0].givenAnswer=[];
                     sectionQuestions1_2[0].givenAnswer.push(_ALL_Options[1]);
                     sectionQuestions1_2[0].total_score= parseFloat(_AllScores[1]);
                     document.getElementById(_idsAll[1]).checked = true;
                  
               }
               else if(e.target.value>=56 && e.target.value<=65)
               {
                  sectionQuestions1_2[0].givenAnswer=[];
                  sectionQuestions1_2[0].givenAnswer.push(_ALL_Options[2]);
                  sectionQuestions1_2[0].total_score= parseFloat(_AllScores[2]);
                  document.getElementById(_idsAll[2]).checked = true;
            
            }


            else if(e.target.value>=66 && e.target.value<=75)
            {
               sectionQuestions1_2[0].givenAnswer=[];
               sectionQuestions1_2[0].givenAnswer.push(_ALL_Options[3]);
               sectionQuestions1_2[0].total_score= parseFloat(_AllScores[3]);
               document.getElementById(_idsAll[3]).checked = true;
            }
            else if(e.target.value>=76 && e.target.value<85)
            {
               sectionQuestions1_2[0].givenAnswer=[];
               sectionQuestions1_2[0].givenAnswer.push(_ALL_Options[4]);
               sectionQuestions1_2[0].total_score= parseFloat(_AllScores[4]);
               document.getElementById(_idsAll[4]).checked = true;
            }

            else if(e.target.value>=85 )
            {
               sectionQuestions1_2[0].givenAnswer=[];
               sectionQuestions1_2[0].givenAnswer.push(_ALL_Options[5]);
               sectionQuestions1_2[0].total_score= parseFloat(_AllScores[5]);
               document.getElementById(_idsAll[5]).checked = true;
            }
           
            console.log("__________________________________________");
            console.log(sectionQuestions1_2);
            console.log("__________________________________________");

            this.setState({
            SelectedLifeCycleState: e.target.value
            });
  
       }


      onChangeSelectedCapitalSafety(sectionQuestions2_1, e, sectionQuestions2_1_Sliders) {
         this.setState({
            submitted: false
          });

         for(let _t=0; _t<sectionQuestions2_1_Sliders.length; _t++)
         {
            if(e.target.value===sectionQuestions2_1_Sliders[_t].value)
            {
               sectionQuestions2_1[0].givenAnswer=[];
               sectionQuestions2_1[0].givenAnswer.push( sectionQuestions2_1[0].optionsDetails[_t]); 
         sectionQuestions2_1[0].total_score= sectionQuestions2_1[0].optionsDetails[_t].OptionScoreValue; 
            }
         }
         console.log("*****************************")
         console.log(sectionQuestions2_1)
         console.log("*****************************")
         this.setState({
            SelectedCapitalSafety: e.target.value
         });
      }

      onChangeSelectedRiskPreference(sectionQuestions2_1, e, sectionQuestions2_1_Sliders) {
         this.setState({
            submitted: false
          });
         for(let _t=0; _t<sectionQuestions2_1_Sliders.length; _t++)
         {
            if(e.target.value===sectionQuestions2_1_Sliders[_t].value)
            {
               sectionQuestions2_1[1].givenAnswer=[];
               sectionQuestions2_1[1].givenAnswer.push( sectionQuestions2_1[1].optionsDetails[_t]); 
         sectionQuestions2_1[1].total_score= sectionQuestions2_1[1].optionsDetails[_t].OptionScoreValue; 
            }
         }
         console.log("*****************************")
         console.log(sectionQuestions2_1)
         console.log("*****************************")
         this.setState({
            SelectedRiskPreference: e.target.value
         });
        
      }
     
      onChangeSelectedProductPreference(sectionQuestions2_1, e, sectionQuestions2_1_Sliders) {
         this.setState({
            submitted: false
          });
         for(let _t=0; _t<sectionQuestions2_1_Sliders.length; _t++)
         {
            if(e.target.value===sectionQuestions2_1_Sliders[_t].value)
            { 
               sectionQuestions2_1[2].givenAnswer=[];
               sectionQuestions2_1[2].givenAnswer.push( sectionQuestions2_1[2].optionsDetails[_t]); 
         sectionQuestions2_1[2].total_score= sectionQuestions2_1[2].optionsDetails[_t].OptionScoreValue; 
            }
         }
        
         console.log("*****************************")
         console.log(sectionQuestions2_1)
         console.log("*****************************")
         this.setState({
            SelectedProductPreference: e.target.value
         });
      }

      
   

      // //////////////////////////////////
      handleValueChanges( sectionQuestions,  optionsDetails, allIDslength, i, e , num, questionTypeCode) 
      {
         this.setState({
            submitted: false,
              });
      
       var section2Id= e.target.id;
       section2Id= section2Id.replace(/.$/,'');
       section2Id=   Number(section2Id);
       let ListSliderValues_1_2=[25, 45, 55, 65, 75, 85 ];
     
       if(section2Id===121)
       {
          let index_= e.target.id.substr(-1);
          index_= Number(index_); 

         this.setState({
            SelectedLifeCycleState: ListSliderValues_1_2[index_]
          });
       }

       if(section2Id===152 &&e.target.checked )
       {
       
         this.setState({
            portfolioSizeCheck: 1,
             dataFillingMessageError:''
          });
       }
      


       
       
         let idsall=[];
         let AllScores=[];
         let ListofAllAnswers=[];
         for (let m = 0; m < allIDslength; m++) 
         {
            var str1 = e.target.id.replace(/.$/,m);
            idsall.push(str1);
            AllScores.push(document.getElementById(str1).value);
         }
   
         let totalscore=0.0;
         if(questionTypeCode===20) 
         {
            for (let x = 0; x <idsall.length; x++) {

               const IDCHECKED = document.getElementById(idsall[x]).checked;
         
               if(IDCHECKED)
               {
                  ListofAllAnswers.push(optionsDetails[x]);
                  totalscore = parseFloat(AllScores[x]) + parseFloat(totalscore);
               }
            }
         sectionQuestions[num].total_score= parseFloat(totalscore);
        sectionQuestions[num].givenAnswer= ListofAllAnswers;
        console.log('############################################################');
         console.log(sectionQuestions);
         console.log('############################################################');
       }
   else
   {
      ListofAllAnswers.push(optionsDetails[i]);
      sectionQuestions[num].givenAnswer = ListofAllAnswers;
      console.log('############################################################');
      console.log(sectionQuestions);
      console.log('############################################################');
   totalscore= e.target.value;
   sectionQuestions[num].total_score= parseFloat(totalscore);
   }
      }

      ////////////////////////////////////////////////// 
      

      handlePrimaryValueChangess(question, e ,  primaryid) 
      { 
         

            if(e.target.checked)
            {

               if(question==='sectionQuestions1_1')

               {
                  this.setState({
                  Primaryoption1: primaryid,
                     });
                  }

                  else  {
                     this.setState({
                        Primaryoption4: primaryid,
                           });
                        }

                  }
               
            }

            

       

       
         
     
     ////////////////////////////////////////////


 handleValueChangess(quest, sectionQuestions,  optionsDetails, allIDslength, i, e , num, questionTypeCode, primaryid) 
 { 


  


   this.setState({
      submitted: false,
     
    });

   let idsall=[];
   let AllScores=[];
   let ListofAllAnswers=[];
   for (let m = 0; m < allIDslength; m++) {
      var str1 = e.target.id.replace(/.$/,m);
      idsall.push(str1);
      AllScores.push(document.getElementById(str1).value);
   }
   let totalscore=0.0;
   if(questionTypeCode===20) {
      if(e.target.checked)
      {
         document.getElementById(primaryid).disabled= false;
      }
      else{
         if(Number(quest)===1)
  {
   this.setState({
      Primaryoption1: 0,
         });
  }

  if(Number(quest)===4)
  {
   this.setState({
      Primaryoption4: 0,
         });
  }
         

          document.getElementById(primaryid).checked = false ;
         document.getElementById(primaryid).disabled= true;
      }

for (let x = 0; x <idsall.length; x++) {
const IDCHECKED = document.getElementById(idsall[x]).checked;
if(IDCHECKED)
{

   ListofAllAnswers.push(optionsDetails[x]);

   totalscore = parseFloat(AllScores[x]) + parseFloat(totalscore);
}
}

  sectionQuestions[num].givenAnswer= ListofAllAnswers;
  sectionQuestions[num].total_score= parseFloat(totalscore);
  console.log('############################################################');
   console.log(sectionQuestions);
   console.log('############################################################');
 }
else
{
   ListofAllAnswers.push(optionsDetails[i]);
sectionQuestions[num].givenAnswer = ListofAllAnswers;
console.log('############################################################');
   console.log(sectionQuestions);
   console.log('############################################################');
totalscore= e.target.value;
sectionQuestions[num].total_score= parseFloat(totalscore);
}
}
////////////////////////////////////////////

submitData()
      {


try {
   let firstSectionwithPrimarycheck= this.state.sectionQuestions1_1
   var primary1= this.state.Primaryoption1.slice(-2);
   var outterIndex= primary1.slice(0,1);
  

   var innerIndex= primary1.slice(-1);
   innerIndex= Number(innerIndex)+ 1;
  
   
   for(let x= 0; x<firstSectionwithPrimarycheck[outterIndex].givenAnswer.length; x++ )
   {
      
      if (firstSectionwithPrimarycheck[outterIndex].givenAnswer[x].OptionID=== Number(innerIndex) )
      {
var primaryoption = firstSectionwithPrimarycheck[outterIndex].givenAnswer[x].OptionText;

primaryoption = primaryoption + "   (Primary)";

firstSectionwithPrimarycheck[outterIndex].givenAnswer[x].OptionText= primaryoption;


this.setState({
   sectionQuestions1_1: firstSectionwithPrimarycheck
});
      }
      
   }  
} catch (error) {
   
}

/////////////////////////////////////////////
try {
   
   let fourthSectionwithPrimarycheck= this.state.sectionQuestions1_4
   var primary4= this.state.Primaryoption4.slice(-2);
   var _outterIndex= primary4.slice(0,1);
 


   var _innerIndex= primary4.slice(-1);
   _innerIndex= Number(_innerIndex)+ 1;
  
   
   for(let x= 0; x<fourthSectionwithPrimarycheck[_outterIndex].givenAnswer.length; x++ )
   {
      
      if (fourthSectionwithPrimarycheck[_outterIndex].givenAnswer[x].OptionID=== Number(_innerIndex) )
      {
var primaryoption4 = fourthSectionwithPrimarycheck[_outterIndex].givenAnswer[x].OptionText;

primaryoption4 = primaryoption4 + "   (Primary)";

fourthSectionwithPrimarycheck[_outterIndex].givenAnswer[x].OptionText= primaryoption4;


this.setState({
   sectionQuestions1_4: fourthSectionwithPrimarycheck
});
      }
      
   }  
} catch (error) {
   
}





// ////////////////////////////
        

       

         
         this.openModal();
         let finalTotalScore=0.0;

         const AllQuestionsArray=[];
         AllQuestionsArray.push(this.state.sectionQuestions1_1);
         AllQuestionsArray.push(this.state.sectionQuestions1_2);
         AllQuestionsArray.push(this.state.sectionQuestions1_3);
         AllQuestionsArray.push(this.state.sectionQuestions1_4);
         AllQuestionsArray.push(this.state.sectionQuestions1_5);
         AllQuestionsArray.push(this.state.sectionQuestions1_6);
         AllQuestionsArray.push(this.state.sectionQuestions1_7);
         AllQuestionsArray.push(this.state.sectionQuestions1_8);
         AllQuestionsArray.push(this.state.sectionQuestions1_9);
         AllQuestionsArray.push(this.state.sectionQuestions2_1);
         
         const portfolioSize= this.state.sectionQuestions1_5[1].givenAnswer[0].SerialNumber;
         console.log(portfolioSize);
         let portfolioSizeValue=0;
         
         if(portfolioSize==='A'|| portfolioSize==='B'){
            portfolioSizeValue=40;
         }
         else if(portfolioSize==='C')
         {
            portfolioSizeValue=60;
         }
         else if(portfolioSize==='D')
         {
            portfolioSizeValue=80;
         }

         let AllAnswers=[];
         let testobj={};
         for(let t = 0; t< AllQuestionsArray.length;t++)
         {
            for(let tt = 0; tt< AllQuestionsArray[t].length;tt++)
               {
                  finalTotalScore+=AllQuestionsArray[t][tt].total_score;
                  testobj={};
                  testobj['GivenAnswer']=[]; 
                  testobj['Question']=AllQuestionsArray[t][tt].QuestionID;
                  testobj['options']=AllQuestionsArray[t][tt].optionsDetails;
                  testobj['total_score']=AllQuestionsArray[t][tt].total_score;
                  testobj['GivenAnswer'].push(AllQuestionsArray[t][tt].givenAnswer);
                  AllAnswers.push(  testobj );
               }
         }

         console.log("get Model Types as per scores:"+finalTotalScore+" and portfolioSizeValue:"+portfolioSizeValue);
         IPSDataService.getModelTypes(finalTotalScore,this.state.SelectedQuestionareType, portfolioSizeValue)
         .then(response => {
            
         console.log(response);
         

         const modelTypeNAme= response['data'][0].name;
         const _return =   response['data'][0].returnValue;
         const _yield =   response['data'][0].yield;
         const _standardDev =   response['data'][0].standardDeviation;
         const _sharpeRatio =   response['data'][0].sharpeRatio;
         let modelvalues= [];
         modelvalues.push(_return);
         modelvalues.push(_yield);
         modelvalues.push(_standardDev);
         modelvalues.push(_sharpeRatio);

        

         let sampleArray = ['Asset Class', '%'];
         let assetClassArray=[];
         assetClassArray.push(sampleArray);

         for(let i=0; i<response['data'].length; i++)
         {
            let sample=[];
            sample.push(response['data'][i].assetClass);
            sample.push(parseFloat(response['data'][i].assetClassValue));
            assetClassArray.push(sample);
         }
        
         console.log("Classes data for calculated model:"+assetClassArray);

         this.setState({
            CalculatedModelType : modelTypeNAme,
            CalculatedModelTypeValues: modelvalues, 
            PreliminaryRiskAssessmentChart:assetClassArray ,
         });
        

         
         })
         .catch(e => {
            console.log(e);
         });

         // ////////////////////////////////////////////////////////////////////////////////////////////////

         IPSDataService.getAllModelTypes(this.state.SelectedQuestionareType, portfolioSizeValue)
         .then(response => {
            
            console.log("Now get all models of portfolioSizeValue: "+ portfolioSizeValue)
         console.log(response);

         

         let CustomModelArray = [];
         let listOfAllModels= [];
         let ALL_MODEL_DETAILS =[];
         

         for(let i=0; i<response['data'].length; i++)
         {
            listOfAllModels.push(response['data'][i].name);
            ALL_MODEL_DETAILS.push(response['data'][i]);
            
            if(this.state.CalculatedModelType===response['data'][i].name) // initially it will have Calculated/Suggested model
            {
            CustomModelArray.push(response['data'][i]);
            }
         }

         console.log("Initial custom model:");
         console.log(CustomModelArray);

         const DifferentModels= [...new Set(listOfAllModels)];

         console.log("All models:");
         console.log(DifferentModels);

         
         let _sampleArray = ['Asset Class', '%'];
         let CustomAssetClassArray=[];
         CustomAssetClassArray.push(_sampleArray);

         for(let i=0; i<response['data'].length; i++)
         {
            if(this.state.CalculatedModelType===response['data'][i].name)
            {
            let sample=[];
            sample.push(response['data'][i].assetClass);
            sample.push(parseFloat(response['data'][i].assetClassValue));
            CustomAssetClassArray.push(sample);
            }
         }

         this.setState({
            
            _ALL_Models: DifferentModels,
            ALL_MODEL_DETAILS_Array: ALL_MODEL_DETAILS,
            Custom_ModelArray : CustomModelArray,
            CustomModelChart: CustomAssetClassArray,
         });
        
        
         
         })
         .catch(e => {
            console.log(e);
         });
    
      }


      /////////////////////////////////////////




handleOtherModelTypeChanges( model, e ) 
{ 
let n = this.state.Custom_ModelArray.length;
let ChangedmodelArray=[];


console.log("All Models:");
console.log(this.state.ALL_MODEL_DETAILS_Array);

         for(let i=0; i<this.state.ALL_MODEL_DETAILS_Array.length; i++)
         {
            if(model===this.state.ALL_MODEL_DETAILS_Array[i].name)
            {
               ChangedmodelArray.push(this.state.ALL_MODEL_DETAILS_Array[i]);
            }
         }

         // ///////////////////////
         let _sampleArray = ['Asset Class', '%'];
         let CustomAssetClassChartArray=[];
         CustomAssetClassChartArray.push(_sampleArray);

         for(let i=0; i<ChangedmodelArray.length; i++)
         {
            let sample=[];
            sample.push(ChangedmodelArray[i].assetClass);
            sample.push(parseFloat(ChangedmodelArray[i].assetClassValue));
            CustomAssetClassChartArray.push(sample);
            
         }

         this.setState({
            CustomModelChart : CustomAssetClassChartArray,
            Custom_Model:model,
            Custom_ModelArray : ChangedmodelArray,
         });

         
        /*
         for(let i=0; i<n; i++)
         {
            let td= document.getElementById(String("customizedTDValue"+String(i)));
            td.innerHTML=ChangedmodelArray[i].assetClassValue + "%  <img alt =\"\"  src=\"assets/edit_icon.svg\" className=\"edit-icon\"/>";
   
         }
         

         document.getElementById(String("modelValues"+String(0))).innerHTML=ChangedmodelArray[0].returnValue + "%";
         document.getElementById(String("modelValues"+String(1))).innerHTML=ChangedmodelArray[0].yield + "%";
         document.getElementById(String("modelValues"+String(2))).innerHTML=ChangedmodelArray[0].standardDeviation + "%";
         document.getElementById(String("modelValues"+String(3))).innerHTML=ChangedmodelArray[0].sharpeRatio + "%";
         */
       
   
}

reloadData(e)
{

   

   IPSDataService.getCustomizedRetunValues()
         .then(response => {

            
            console.log("______________Current Custom_ModelArray _________________");
            console.log(this.state.Custom_ModelArray);
            console.log("__________________________________________");
         
////////////////////////////
 
  let _risk_=0.0;
  let __Return__=0.0;
  let __Yield__=0.0;
 let FI_EM = [];
 let FI_MUNI  =[];
 let FI_TIPS  =[];
 let FI_US  =[];
 let  EQ_US  =[];
 let  EQ_KSA  =[];
 let   EQ_EM  =[];
 let  HF_ALL  =[];
 let  CM_EGY  =[];
 let CM_MTL  =[];
 let CM_NON_MTL  =[];
 let  CM_GLD  =[];
 let REIT_US  =[];
 let MMF_US  =[];
 let  PE_GRTH  =[];
 let PE_VC =[];
let PD =[];
let   RE_DEV= [];
let LEV_ALL=[];

let covArray=[];


  for(let nn=0; nn<response['data'].length; nn++)
  {
    let  _cov_=0.0;

      FI_EM.push(Number(response['data'][nn].FI_EM)*12);
  FI_MUNI.push(Number(response['data'][nn].FI_MUNI)*12);
  FI_TIPS.push(Number(response['data'][nn].FI_TIPS)*12);
  FI_US.push(Number(response['data'][nn].FI_US)*12);
   EQ_US.push(Number(response['data'][nn].EQ_US)*12);
   EQ_KSA.push(Number(response['data'][nn].EQ_KSA)*12); 
    EQ_EM.push(Number(response['data'][nn].EQ_EM)*12);  
   HF_ALL.push(Number(response['data'][nn].HF_ALL)*12);  
   CM_EGY.push(Number(response['data'][nn].CM_EGY)*12);  
  CM_MTL.push(Number(response['data'][nn].CM_MTL)*12);  
  CM_NON_MTL.push(Number(response['data'][nn].CM_NON_MTL)*12); 
   CM_GLD.push(Number(response['data'][nn].CM_GLD)*12);  
  REIT_US.push(Number(response['data'][nn].REIT_US)*12);  
  MMF_US.push(Number(response['data'][nn].MMF_US)*12);  
   PE_GRTH.push(Number(response['data'][nn].PE_GRTH)*12);  
  PE_VC.push(Number(response['data'][nn].PE_VC)*12); 
  PD.push(Number(response['data'][nn].PD)*12); 
  RE_DEV.push(Number(response['data'][nn].RE_DEV)*12);
  LEV_ALL.push(Number(response['data'][nn].LEV_ALL)*12);
  



  _cov_ =  _cov_+   ((Number(this.state.Custom_ModelArray[0].assetClassValue))/100) *(Number(FI_EM[nn])) ;
  
  _cov_ =  _cov_ +   ((Number(this.state.Custom_ModelArray[1].assetClassValue))/100) *(Number(FI_MUNI[nn])) ;
  
  _cov_ =  _cov_+    ((Number(this.state.Custom_ModelArray[2].assetClassValue))/100) *(Number(FI_TIPS[nn])) ;
  
  _cov_ =  _cov_+ ((Number(this.state.Custom_ModelArray[3].assetClassValue))/100) *(Number(FI_US[nn])) ;
  
  _cov_ =  _cov_+  ((Number(this.state.Custom_ModelArray[4].assetClassValue))/100) *(Number(EQ_US[nn])) ;
  _cov_ =  _cov_+ ((Number(this.state.Custom_ModelArray[5].assetClassValue))/100) *(Number(EQ_KSA[nn])) ;
  _cov_ =  _cov_+   ((Number(this.state.Custom_ModelArray[6].assetClassValue))/100) *(Number(EQ_EM[nn])) ;
  _cov_ =  _cov_+  ((Number(this.state.Custom_ModelArray[7].assetClassValue))/100) *(Number(HF_ALL[nn])) ;
  _cov_ =  _cov_+  ((Number(this.state.Custom_ModelArray[8].assetClassValue))/100) *(Number(CM_EGY[nn])) ;
  _cov_ =  _cov_+ ((Number(this.state.Custom_ModelArray[9].assetClassValue))/100) *(Number(CM_MTL[nn])) ;
  _cov_ =  _cov_+   ((Number(this.state.Custom_ModelArray[10].assetClassValue))/100) *(Number(CM_NON_MTL[nn])) ;
  _cov_ =  _cov_+  ((Number(this.state.Custom_ModelArray[11].assetClassValue))/100) *(Number(CM_GLD[nn])) ;
  _cov_ =  _cov_+   ((Number(this.state.Custom_ModelArray[12].assetClassValue))/100) *(Number(REIT_US[nn])) ;
  _cov_ =  _cov_+   ((Number(this.state.Custom_ModelArray[13].assetClassValue))/100) *(Number(MMF_US[nn])) ;
  _cov_ =  _cov_+   ((Number(this.state.Custom_ModelArray[14].assetClassValue))/100) *(Number(PE_GRTH[nn])) ;
  _cov_ =  _cov_+   ((Number(this.state.Custom_ModelArray[15].assetClassValue))/100) *(Number(PE_VC[nn])) 
  _cov_ =  _cov_+   ((Number(this.state.Custom_ModelArray[16].assetClassValue))/100) *(Number(PD[nn])) ;
  _cov_ =  _cov_+  ((Number(this.state.Custom_ModelArray[17].assetClassValue))/100) *(Number(RE_DEV[nn])) ;

  _cov_ =  _cov_+  ((Number(this.state.Custom_ModelArray[18].assetClassValue))/100) *(Number(LEV_ALL[nn]));
 

  
  _risk_= _risk_+  _cov_* ((Number(this.state.Custom_ModelArray[nn].assetClassValue))/100);
  covArray.push(_cov_);
     __Return__=__Return__+  ((Number(this.state.Custom_ModelArray[nn].assetClassValue))/100) * (Number(response['data'][nn].custom_mu))*12;
     __Yield__=__Yield__+  ((Number(this.state.Custom_ModelArray[nn].assetClassValue))/100) * (Number(response['data'][nn].custom_yield));
     
         }
         
// ///////////////////
let __sharpeRatio__= 0.0;
let __standardDev__=0.0;
__Return__=__Return__*100;
     __Yield__=__Yield__*100;

__sharpeRatio__=  ((Number(__Return__ ))/ (Math.sqrt( _risk_ )))/100;
__standardDev__= (Math.sqrt( _risk_ ))*100 

// alert(__Return__+ "   is the return value")
console.log(__Return__ + " is the return value");
// alert(__Yield__ + "   is the yield value")
console.log(__Yield__ +"   is the yield value");





let final_CustomizedArray= this.state.Custom_ModelArray;
final_CustomizedArray[0].returnValue= parseFloat(__Return__).toFixed(1);
final_CustomizedArray[0].yield= parseFloat(__Yield__).toFixed(1);
final_CustomizedArray[0].standardDeviation= parseFloat(__standardDev__).toFixed(1);
final_CustomizedArray[0].sharpeRatio= parseFloat(__sharpeRatio__).toFixed(1);

        
         this.setState({
           
            Custom_ModelArray: final_CustomizedArray, 
         });
         })
         .catch(e => {
            console.log(e);
         });
   

}

handleCustomClassChanges(index,className,e)
{
  
   let arrayTemp=this.state.Custom_ModelArray;
   let totalSum=parseFloat(0);
   let reloadbtnTemp=true;
   let _sampleArray = ['Asset Class', '%'];
   let CustomAssetClassArray=[];
   CustomAssetClassArray.push(_sampleArray);
  /////////// End of for required data for custome model chart////////


   for(let i=0; i<arrayTemp.length; i++)
         {
            if(className==arrayTemp[i].assetClass)
            {
               arrayTemp[i].assetClassValue=e.target.value
            }
            totalSum=parseFloat(totalSum)+parseFloat(arrayTemp[i].assetClassValue);
           
            /////////// for required data for custome model chart////////
            let sample=[];
            sample.push(arrayTemp[i].assetClass);
            sample.push(parseFloat(arrayTemp[i].assetClassValue));
            CustomAssetClassArray.push(sample);
         }

         console.log("totalSum:"+totalSum)
         if(parseFloat(totalSum)>=parseFloat(99.9) && parseFloat(totalSum)<=parseFloat(100))
         {
            reloadbtnTemp=true;
         }
         else
         {
            reloadbtnTemp=false;
         }

         this.setState({
            Custom_ModelArray : arrayTemp,
            reloadbtn: reloadbtnTemp,
            CustomModelChart : CustomAssetClassArray
         });
        

}

// ///////////////////////////////

handleTypesOfQuestionaresListChanges(id,e)
{  
    this.setState({
        sectionQuestions1_1: [],
        sectionQuestions1_2:[],
        sectionQuestions1_3:[],
        sectionQuestions1_4:[],
        sectionQuestions1_5:[],
        sectionQuestions1_6:[],
        sectionQuestions1_7:[],
        sectionQuestions1_8:[],
        sectionQuestions1_9:[],
        sectionQuestions2_1:[],
     });
        var QuestionareType=id;
        this.retrievesectionQuestionsListDetails(11,QuestionareType,'sectionQuestions1_1');
        this.retrievesectionQuestionsListDetails(12,QuestionareType,'sectionQuestions1_2');
        this.retrievesectionQuestionsListDetails(13,QuestionareType,'sectionQuestions1_3');
        this.retrievesectionQuestionsListDetails(14,QuestionareType,'sectionQuestions1_4');
        this.retrievesectionQuestionsListDetails(15,QuestionareType,'sectionQuestions1_5');
        this.retrievesectionQuestionsListDetails(16,QuestionareType,'sectionQuestions1_6');
        this.retrievesectionQuestionsListDetails(17,QuestionareType,'sectionQuestions1_7');
        this.retrievesectionQuestionsListDetails(18,QuestionareType,'sectionQuestions1_8');
        this.retrievesectionQuestionsListDetails(19,QuestionareType,'sectionQuestions1_9');
        this.retrievesectionQuestionsListDetails(21,QuestionareType,'sectionQuestions2_1'); 
        this.setState({
         SelectedQuestionareType: id
        });
}

retrieveTypesOfQuestionares() {
   IPSDataService.getTypesOfQuestionares()
     .then(response => {
       this.setState({
         TypesOfQuestionaresList: response.data
       });
       console.log(response.data);
     })
     .catch(e => {
       console.log(e);
     });
 }

 retrievesectionQuestionsListDetails(SectionID,QuestionareType,QuestionSection) {   
    
   IPSDataService.getSectionQuestionsListNew(SectionID,QuestionareType)

     .then(response => {
       var questionsData = [];
       var options=[];
       var CurrentQuestionID=response.data[0]["QuestionID"];
       var j=0;
       var k=0;
       for(var i=0;i<response.data.length;i++)
       { 
         if(i+1===response.data.length) // check if it last index, just push all to questionsData array and break
         { 
            options[j++]={OptionID:response.data[i]["OptionID"],OptionText:response.data[i]["OptionText"],SerialNumber:response.data[i]["SerialNumber"],OptionScoreValue:response.data[i]["OptionScoreValue"]};
            questionsData[k]={SectionID:response.data[i]['SectionID'],
                              QuestionID:response.data[i]['QuestionID'],
                              SerialNumber: response.data[i]['SerialNumber'],
                              QuestionText:response.data[i]["QuestionText"],
                              SuggestionType:response.data[i]['SuggestionType'],
                              SuggestionValue:response.data[i]['SuggestionValue'],
                              illustration: response.data[i]['Illustration'],
                              CommentHeading:response.data[i]['CommentHeading'],
                              HasComments:response.data[i]['HasComments'],
                              QuestionTypeDescription:response.data[i]['QuestionTypeDescription'],
                              QuestionTypeCode:response.data[i]['QuestionTypeCode'],
                              givenAnswer:[],
                              givenCommnets:"", 
                              total_score:0.0, 
                              optionsDetails:options}; 
            break;
         }
         else
         {
            
            if(CurrentQuestionID!==response.data[i]["QuestionID"])
            {  
               
               questionsData[k++]={SectionID:response.data[i-1]['SectionID'],
                                   QuestionID:response.data[i-1]['QuestionID'],
                                   SerialNumber: response.data[i-1]['SerialNumber'],
                                   QuestionText:response.data[i-1]["QuestionText"],
                                   SuggestionType:response.data[i-1]['SuggestionType'],
                                   SuggestionValue:response.data[i-1]['SuggestionValue'],
                                   illustration: response.data[i-1]['Illustration'],
                                   CommentHeading:response.data[i-1]['CommentHeading'],
                                   HasComments:response.data[i-1]['HasComments'],
                                   QuestionTypeDescription:response.data[i-1]['QuestionTypeDescription'],
                                   QuestionTypeCode:response.data[i-1]['QuestionTypeCode'],
                                   givenAnswer:[],
                                   givenCommnets:"", 
                                   total_score:0.0, 
                                   optionsDetails:options}; 
               j=0;
               options=[];
            }
         }
         CurrentQuestionID=response.data[i]["QuestionID"];
         options[j++]={OptionID:response.data[i]["OptionID"],OptionText:response.data[i]["OptionText"],SerialNumber:response.data[i]["SerialNumber"],OptionScoreValue:response.data[i]["OptionScoreValue"]};
  
       }
         this.setState({
            [QuestionSection]: questionsData,  
       });

       if(QuestionSection==="sectionQuestions1_2")
       {
         this.fillStateOfLife();
       }
      
     })
     .catch(e => {
       console.log(e);
     });
 }
 //////////////////////////////////

    render() {
        const { _100DollarChart, PreliminaryRiskAssessmentChart,CalculatedModelType,Custom_Model,Custom_ModelArray,CustomModelChart,_ALL_Models, ALL_MODEL_DETAILS_Array, CalculatedModelTypeValues, TypesOfQuestionaresList,LifeCycleState,SelectedLifeCycleState,sectionQuestions2_1_Sliders,SelectedCapitalSafety,SelectedRiskPreference,SelectedProductPreference, knowledgeLevelList,portfolioSizeList,stateOfLifeList, dependents,sectionQuestions1_0,sectionQuestions1_1,sectionQuestions1_2,sectionQuestions1_3,sectionQuestions1_4,sectionQuestions1_5,sectionQuestions1_6,sectionQuestions1_7,sectionQuestions1_8,sectionQuestions1_9,sectionQuestions2_1,dataFillingMessageError,dataFillingMessageSuccess } = this.state;
        
        const countryList = ["Afghanistan",	"Albania",	"Algeria",	"American Samoa",	"Andorra",	"Angola",	"Anguilla",	"Antarctica",	"Antigua and Barbuda",	"Argentina",	"Armenia",	"Aruba",	"Australia",	"Austria",	"Azerbaijan",	"Bahamas",	"Bahrain",	"Bangladesh",	"Barbados",	"Belarus",	"Belgium",	"Belize",	"Benin",	"Bermuda",	"Bhutan",	"Bolivia (Plurinational State of)",	"Bonaire, Sint Eustatius and Saba",	"Bosnia and Herzegovina",	"Botswana",	"Bouvet Island",	"Brazil",	"British Indian Ocean Territory",	"Brunei Darussalam",	"Bulgaria",	"Burkina Faso",	"Burundi",	"Cabo Verde",	"Cambodia",	"Cameroon",	"Canada",	"Cayman Islands",	"Central African Republic",	"Chad",	"Chile",	"China",	"Christmas Island",	"Cocos (Keeling) Islands",	"Colombia",	"Comoros",	"Congo (the Democratic Republic of the)",	"Congo",	"Cook Islands",	"Costa Rica",	"Croatia",	"Cuba",	"Curaçao",	"Cyprus",	"Czechia",	"Côte d'Ivoire",	"Denmark",	"Djibouti",	"Dominica",	"Dominican Republic",	"Ecuador",	"Egypt",	"El Salvador",	"Equatorial Guinea",	"Eritrea",	"Estonia",	"Eswatini",	"Ethiopia",	"Falkland Islands [Malvinas]",	"Faroe Islands",	"Fiji",	"Finland",	"France",	"French Guiana",	"French Polynesia",	"French Southern Territories",	"Gabon",	"Gambia",	"Georgia",	"Germany",	"Ghana",	"Gibraltar",	"Greece",	"Greenland",	"Grenada",	"Guadeloupe",	"Guam",	"Guatemala",	"Guernsey",	"Guinea",	"Guinea-Bissau",	"Guyana",	"Haiti",	"Heard Island and McDonald Islands",	"Holy See",	"Honduras",	"Hong Kong",	"Hungary",	"Iceland",	"India",	"Indonesia",	"Iran (Islamic Republic of)",	"Iraq",	"Ireland",	"Isle of Man",	"Israel",	"Italy",	"Jamaica",	"Japan",	"Jersey",	"Jordan",	"Kazakhstan",	"Kenya",	"Kiribati",	"Korea (the Democratic People's Republic of)",	"Korea (the Republic of)",	"Kuwait",	"Kyrgyzstan",	"Lao People's Democratic Republic",	"Latvia",	"Lebanon",	"Lesotho",	"Liberia",	"Libya",	"Liechtenstein",	"Lithuania",	"Luxembourg",	"Macao",	"Madagascar",	"Malawi",	"Malaysia",	"Maldives",	"Mali",	"Malta",	"Marshall Islands",	"Martinique",	"Mauritania",	"Mauritius",	"Mayotte",	"Mexico",	"Micronesia (Federated States of)",	"Moldova (the Republic of)",	"Monaco",	"Mongolia",	"Montenegro",	"Montserrat",	"Morocco",	"Mozambique",	"Myanmar",	"Namibia",	"Nauru",	"Nepal",	"Netherlands",	"New Caledonia",	"New Zealand",	"Nicaragua",	"Niger",	"Nigeria",	"Niue",	"Norfolk Island",	"Northern Mariana Islands",	"Norway",	"Oman",	"Pakistan",	"Palau",	"Palestine, State of",	"Panama",	"Papua New Guinea",	"Paraguay",	"Peru",	"Philippines",	"Pitcairn",	"Poland",	"Portugal",	"Puerto Rico",	"Qatar",	"Republic of North Macedonia",	"Romania",	"Russian Federation",	"Rwanda",	"Réunion",	"Saint Barthélemy",	"Saint Helena, Ascension and Tristan da Cunha",	"Saint Kitts and Nevis",	"Saint Lucia",	"Saint Martin (French part)",	"Saint Pierre and Miquelon",	"Saint Vincent and the Grenadines",	"Samoa",	"San Marino",	"Sao Tome and Principe",	"Saudi Arabia",	"Senegal",	"Serbia",	"Seychelles",	"Sierra Leone",	"Singapore",	"Sint Maarten (Dutch part)",	"Slovakia",	"Slovenia",	"Solomon Islands",	"Somalia",	"South Africa",	"South Georgia and the South Sandwich Islands",	"South Sudan",	"Spain",	"Sri Lanka",	"Sudan",	"Suriname",	"Svalbard and Jan Mayen",	"Sweden",	"Switzerland",	"Syrian Arab Republic",	"Taiwan",	"Tajikistan",	"Tanzania, United Republic of",	"Thailand",	"Timor-Leste",	"Togo",	"Tokelau",	"Tonga",	"Trinidad and Tobago",	"Tunisia",	"Turkey",	"Turkmenistan",	"Turks and Caicos Islands",	"Tuvalu",	"Uganda",	"Ukraine",	"United Arab Emirates",	"United Kingdom of Great Britain and Northern Ireland",	"United States Minor Outlying Islands",	"United States of America",	"Uruguay",	"Uzbekistan",	"Vanuatu",	"Venezuela (Bolivarian Republic of)",	"Viet Nam",	"Virgin Islands (British)",	"Virgin Islands (U.S.)",	"Wallis and Futuna",	"Western Sahara",	"Yemen",	"Zambia",	"Zimbabwe",	"Åland Islands"];
        
       const pieOptions = {
         title: '',
         pieHole: 0.5,
         legend: { position: 'left',
         fontSize: 10, }
       }

        return (
   
      <div>
         <div className="clearfix"></div>
      <ReactTooltip />   
         <div>
         <section>
            <div className="center-wrapper">

               {/* ////////////////// STEP 0  ///////////////////*/}
               <div className="main-container card investorType">
                  <div className="row">
                     <div className="col-md-6 col-xs-12">
                        <div className="card-title"> Please select your investor type</div>
                        <div className="row" style={{marginTop:'2.5rem'}}>
                           { TypesOfQuestionaresList && TypesOfQuestionaresList!="Loading options" && TypesOfQuestionaresList.length>0? TypesOfQuestionaresList.map((optionsList, optionIndex)=>(
                           <div className="col-md-6" style={{marginBottom:'10px'}}>
                              <input type="radio" id={String(optionsList.ID+String(optionIndex))} 
                                 name="select" value={optionsList.ID}  
                                 onChange={e => this.handleTypesOfQuestionaresListChanges(optionsList.ID, e)}/>
                              <label for={String(optionsList.ID+String(optionIndex))}>
                                 <div className="row">
                                    <div className=" col-md-8 col-lg-8 col-xs-8">
                                       <div className="card-title" style={{marginTop:"0.75rem"}}>
                                          {optionsList.Title}
                                       </div>
                                    </div>
                                    <div className=" col-md-4 col-lg-4 col-xs-4">
                                       <img alt = "Investor type" src={optionsList.Title==="Family/Office"?"/assets/personal.svg":"/assets/corporate.svg"} width="45px" height="53px"/>
                                    </div>
                                 </div>
                              </label>
                           </div>
                           )): ""
                           
                           }
                       

                        {TypesOfQuestionaresList=="Loading options" ? 
                        <p> Loading options....</p> : ''


                        }
                        </div>
                     </div>
                     <div className="col-md-6 col-xs-12">
                        <div className="card right-side-card">
                           <img alt = "" src="assets/message.svg" width="25px" height="25px" />
                           <div className="right-card-text" style={{marginTop:'0.5rem',lineHeight:"1.25"}}>
                              To work with you effectively in identifying and implementing an appropriate inverstment strategy, it is essential that we clearly understand not only you risk and return objectives, But also your border circumstances and preferance.
                              This brief questionnair will help us develop and understanding of your incestment needs and preferances an will be used to.
                           </div>
                        </div>
                        <button type="submit" className="btn next-btn" id="submit-button-of-investor-type">Next</button>
                     </div>
                  </div>
               </div>
               {/* ///////////////  END OF STEP 0////////////*/}

            
               {/* ////////////////// STEP 1  ///////////////////*/}
               <div className="main-container card">
                  <div className="row">
                     <div className="col-md-7">
                        <div id="questions-container">
                           { sectionQuestions1_1 && sectionQuestions1_1.length>0? sectionQuestions1_1.map((List, index)=>(
                           <div className="card questions-card">
                              <div data-toggle="collapse" className="collapse_title" data-target={"#collapse"+index}>
                                 <i className="icon-action fa fa-chevron-down"></i>
                                 <div className="question-div" data-value={List.QuestionText}>{List.QuestionText}</div>
                                 <img alt = "" src="assets/message.svg" width="17px" height="17px" />
                              </div>
                              <div  className={index===0?"filter-content collapse show":"filter-content collapse"} id={"collapse"+index}>
                              <div className="card-body"  style={{paddingLeft:'0.5rem',  paddingBottom:'0', display: 'block'}}>
                              {List.optionsDetails  &&  List.optionsDetails.length > 0 ? List.optionsDetails.map((optionsList, optionIndex) => (
                              <div className="ps-options-wrapper">
                                 <input type="checkbox" id={String(List.QuestionID+String(optionIndex))}  onChange={e => this.handleValueChangess('1',  sectionQuestions1_1, List.optionsDetails,List.optionsDetails.length, optionIndex, e, index, List.QuestionTypeCode, "pr0".concat(String(List.SectionID).concat(String(index)).concat(String(optionIndex))))} name="ps_checkboxaa" value={optionsList.OptionScoreValue}    className="ps-checkbox"/>
                                 <label for={String(List.QuestionID+String(optionIndex))}>
                                    <div className="option-card">
                                       <i className="fa fa-check"  style={{marginRight:'0.5rem',   display: 'none'}}></i>
                                       {optionsList.OptionText}    

                                       <input type="radio" 
                                          id={"pr0".concat(String(List.SectionID).concat(String(index)).concat(String(optionIndex)))}
                                          disabled
                                          onChange={e => this.handlePrimaryValueChangess( "sectionQuestions1_1",  e,  "pr0".concat(String(List.SectionID).concat(String(index)).concat(String(optionIndex))))}
                                          name={"ps_radio".concat("first").concat(String(List.SectionID))} value="primary" className="ps-radio" /> 
                                 <label for={"pr0".concat(String(List.SectionID).concat(String(index)).concat(String(optionIndex)))}>
                                 <img alt = "" src="assets/primary.svg"  className="ps-tag" id="primary-icon" wwidth="20px" height="20px" />
                                 </label>
                                 <div hidden>
                                 <input type="radio" id={"se0".concat(String(index).concat(String(optionIndex)))} name={"ps_radio".concat("first").concat(String(index)).concat(String(optionIndex))} value="secondary" className="ps-radio"/> 
                                 <label for={"se0".concat(String(index).concat(String(optionIndex)))}>
                                 <img alt = "" src="assets/secondary.svg" className="ps-tag"  id="secondary-icon" width="18px" height="18px"/>
                                 </label>
                                 </div>
                                 </div>
                                 </label>
                              </div>
                              )): 
                              <p> No options found.</p>
                              }
                           </div>
                        </div>
                     </div>
                     )): 
                     <p> No question found.</p>
                     }  
                  </div>
               </div>
               <div className="col-md-5" >
                  <div className="card right-side-card">
                     <img alt = "message" src="assets/message.svg" width="25px" height="25px" />
                     <div className="right-card-text" style={{marginTop:'0.5rem'}}>
                        {
                        sectionQuestions1_1.slice(0, 1).map((List, counting)=>(
                        <div style={{fontSize:'14px'}}> 
                           {sectionQuestions1_1[0]['SuggestionValue']}
                        </div>
                        ))}
                        <div className="row"  style={{marginTop:'1.5rem'}}>
                           <div className="col-sm-6 col-md-12">
                              Click <img alt = "" src="assets/primary.svg"  width="20px" height="20px" style={{marginRight:'0.4rem'}}/>
                              to mark your objective as primary, rest of selected objectives are secondary
                           </div>
                           <div className="col-sm-6 col-md-6" hidden>
                              <img alt = "" src="assets/secondary.svg"  width="20px" height="20px" style={{marginRight:'0.4rem'}}/>
                              Secondary
                           </div>
                        </div>
                     </div>
                  </div>
                  <button type="submit" className="btn next-btn" id="submit-button">Next</button>
                  <div className="back-button" id="back-btn">
                     <img alt = "" src="assets/back_arrow.svg" width="25px" height="45px"/>
                     Back
                  </div>
                  <div id="progress-bar-container">
                     <div className="progress">
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                     </div>
                  </div>
               </div>
               </div>
               </div>
                  {/* ///////////////  END OF STEP 1//////////// */}

               {/* ////////////////// STEP 2  ///////////////////*/}
               <div className="main-container card">
                  <div className="row">
                     <div className="col-md-7">
                        {sectionQuestions1_2  && sectionQuestions1_2.length>0? sectionQuestions1_2.map((List, index)=>(
                        <div id="questions-container">
                           <div className="card questions-card" style={{marginBottom:'0.25rem'}}>
                              <div className="row">
                                 <div className="col-sm-12 col-md-12">
                                    <div className="question-div" >{List.QuestionText}</div>
                                    <img alt = "" src="assets/message.svg" width="17px" height="17px" />
                                 </div>
                              </div>
                           </div>
                           <div className="card-body" style={{paddingLeft:'0.5rem',  paddingBottom:'0'}}>
                           <div className="row">
                              {  
                              List.optionsDetails && List.optionsDetails.length>0 ? List.optionsDetails.map((optionsList, optionIndex)=>(
                              <div className="col-md-12 col-lg-6">
                                 <div className="form-check">
                                    <input type="radio"
                                       id={String(List.QuestionID+String(optionIndex))} 
                                       className="form-check-input" name={"optradio3".concat(index)} 
                                       value=  {String(optionsList.OptionScoreValue)}
                                       onChange={e => this.handleValueChanges(sectionQuestions1_2,List.optionsDetails,List.optionsDetails.length, optionIndex, e, index, List.QuestionTypeCode)}/>
                                    <label className="form-check-label" for={String(List.QuestionID+String(optionIndex))} >   
                                    {optionsList.OptionText}
                                    </label>
                                 </div>
                              </div>
                              )): 
                              <p> No options found.</p>
                              }
                           </div>
                        </div>
                     </div>
                     ) ) : 
                     <p> No question found.</p>
                     }  
                     <div class="lifeCycleState">
                     <p>Select Your Life Cycle State: </p>
                     <br/>
                     <div className="row" style={{marginLeft:'40px'}}>
                        <Box  >
                           <Slider
                              aria-label="Custom LifeCycleState"
                              defaultValue={0}
                              value={SelectedLifeCycleState}
                              min={25}
                              max={85}
                              valueLabelDisplay="on"
                              marks={LifeCycleState}
                              onChange={e =>
                           this.onChangeSelectedLifeCycleState(sectionQuestions1_2, e)}
                           sx={{
                           width: 600,
                           color: '#67707D',
                           }}
                           />
                        </Box>
                     </div>
                     </div>  
                  </div>
                  <div className="col-md-5">
                     <div className="card right-side-card life-cycle-card">
                        <div className="right-card-title">Guidlines for Stages of Life Cycle</div>
                        {                 
                        sectionQuestions1_2.slice(0, 1).map((List, counting)=>(
                        <div className="right-card-text"  style={{marginTop:'0.5rem', lineHeight: '1.25'}}>
                        {sectionQuestions1_2[0]['SuggestionValue']}
                     </div>
                     ))}
                     {   sectionQuestions1_2.slice(0, 1).map((List, counting)=>(
                     <div className="chart-wrapper">
                        <img alt = "" src={List.illustration} width="100%"/>
                     </div>
                     ))}
                  </div>
                  <button type="submit" className="btn next-btn" id="submit-button">Next</button>
                  <div className="back-button" id="back-btn">
                     <img alt = "" src="assets/back_arrow.svg" width="25px" height="45px"/>
                     Back
                  </div>
                  <div id="progress-bar-container">
                     <div className="progress">
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                     </div>
                  </div>
               </div>
               </div>
               </div>
               {/* ///////////////  END OF STEP 2//////////// */}

               {/* ////////////////// STEP 3  ///////////////////*/}
               <div className="main-container card">
                  <div className="row">
                     <div className="col-md-7">
                        <div id="questions-container">
                           <div>
                              { sectionQuestions1_3 && sectionQuestions1_3.length>0? sectionQuestions1_3.map((List, index)=>(
                              <div>
                                 <div className="card questions-card" style={{marginBottom:'0.25rem'}}>
                                    <div className="row">
                                       <div className="col-sm-12 col-md-12">
                                          <div className="question-div" >{List.QuestionText}</div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="card-body"  style={{paddingLeft:'0.5rem',  paddingBottom:'0'}}>
                                 <div className="row">
                                    {List.optionsDetails  &&  List.optionsDetails.length > 0 ? List.optionsDetails.map((optionsList, optionIndex) => (
                                    <div className="col-md-12 col-lg-6">
                                       <div className="form-check">
                                          <input type="radio" id={String(List.QuestionID+String(optionIndex))} className="form-check-input" name={"optradio3".concat(index)}  value=  {String(optionsList.OptionScoreValue)}   onChange={e => this.handleValueChanges(sectionQuestions1_3,List.optionsDetails,List.optionsDetails.length, optionIndex, e, index, List.QuestionTypeCode)}/>
                                          <label className="form-check-label" for={String(List.QuestionID+String(optionIndex))}>   
                                          {optionsList.OptionText}
                                          </label>
                                       </div>
                                    </div>
                                    )):
                                    <p> No options found.</p>
                                    }
                                 </div>
                              </div>
                           </div>
                           )):
                           <p> No question found.</p>
                           }
                        </div>
                     </div>
                  </div>
                  <div className="col-md-5">
                     <div className="card right-side-card" style={{padding: '2.5rem 2rem'}}>
                     <img alt = "" src="assets/message.svg" width="25px" height="25px" />
                     <div className="right-card-text"  style={{marginTop:'0.5rem'}}>
                        {
                        sectionQuestions1_3.slice(0, 1).map((List, counting)=>(
                        <div  style={{fontSize:'14px'}}> 
                           {List.SuggestionValue}
                        </div>
                        ))}
                     </div>
                  </div>
                  <button type="submit" className="btn next-btn" id="submit-button">Next</button>
                  <div className="back-button" id="back-btn">
                     <img alt = "" src="assets/back_arrow.svg" width="25px" height="45px"/>
                     Back
                  </div>
                  <div id="progress-bar-container">
                     <div className="progress">
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                     </div>
                  </div>
               </div>
               </div>
               </div>
            {/* ///////////////  END OF STEP 3//////////// */}
         
               {/* ////////////////// STEP 4  ///////////////////*/}
               <div className="main-container card">
                  <div className="row">
                     <div className="col-md-7">
                        {sectionQuestions1_4  && sectionQuestions1_4.length>0? sectionQuestions1_4.map((List, index)=>(
                        <div id="questions-container">
                           <div className="card questions-card">
                              <div className="row">
                                 <div className="col-sm-12 col-md-12">
                                    <div className="question-div" >{List.QuestionText}</div>
                                 </div>
                              </div>
                           </div>
                           <div className="card-body" style={{paddingLeft:'0.5rem',  paddingBottom:'0'}}>
                           {List.optionsDetails  &&  List.optionsDetails.length > 0 ? List.optionsDetails.map((optionsList, optionIndex) => (
                           <div className="ps-options-wrapper">
                              <input type="checkbox" id={String(List.QuestionID+String(optionIndex))} name="ps_checkbox" value={String(optionsList.OptionScoreValue)} onChange={e => this.handleValueChangess('4', sectionQuestions1_4,List.optionsDetails,List.optionsDetails.length, optionIndex, e, index, List.QuestionTypeCode, "primary".concat(String(optionIndex)))} className="ps-checkbox"/>
                              <label for={String(List.QuestionID+String(optionIndex))}>
                                 <div className="option-card option-card-lg">
                                    <i className="fa fa-check"  style={{marginRight:'0.5rem',   display: 'none'}}></i>
                                    {optionsList.OptionText}
                                    <input type="radio" id={"primary".concat(String(optionIndex))}
                                       disabled

                                       onChange={e => this.handlePrimaryValueChangess( "sectionQuestions1_4",  e,  "pr4".concat(String(List.SectionID).concat(String(index)).concat(String(optionIndex))))}
                                       name={"ps_radio".concat(String(List.SectionID))}  value="primary" className="ps-radio" /> 
                                    <label style={{visibility:optionsList.OptionText==="No Preference"?"hidden":""}} for={"primary".concat(String(optionIndex))}>
                                    <img alt = "" src="assets/primary.svg"  className="ps-tag" id="primary-icon" width="20px" height="20px" />
                              </label>
                              <div hidden>
                              <input type="radio" id={"secondary".concat(String(optionIndex))} name={'ps_radio'.concat(String(optionIndex))} value="secondary" className="ps-radio"/> 
                              <label for={"secondary".concat(String(optionIndex))}>
                              <img alt = "" src="assets/secondary.svg" className="ps-tag"  id="secondary-icon" width="18px" height="18px"/>
                              </label>
                              </div>
                              </div>
                              </label>
                           </div>
                           )): 
                           <p> No options found</p>
                           }       
                        </div>
                     </div>
                     )): 
                     <p> No question found.</p>
                     }
                  </div>
                  <div className="col-md-5">
                     <div className="card right-side-card" style={{padding:'2.5rem 2rem'}}>
                     <img alt = "" src="assets/message.svg" width="25px" height="25px" />
                     <div className="right-card-text" style={{marginTop:'0.5rem'}}>
                        { 
                        sectionQuestions1_4.slice(0, 1).map((List, counting)=>(
                        <div  style={{fontSize:'14px'}}> 
                           {List.SuggestionValue}
                        </div>
                        ))}
                        <div className="row"  style={{marginTop:'1.5rem'}}>
                           <div className=" col-sm-6 col-md-12">
                              Click <img alt = "" src="assets/primary.svg"  width="20px" height="20px" style={{marginRight:'0.4rem'}}/>
                              to mark your objective as primary, rest of selected objectives are secondary
                           </div>
                           <div className=" col-sm-6 col-md-6" hidden>
                              <img alt = "" src="assets/secondary.svg"  width="20px" height="20px" style={{marginRight:'0.4rem'}}/>
                              Secondary
                           </div>
                        </div>
                     </div>
                  </div>
                  <button type="submit" className="btn next-btn" id="submit-button">Next</button>
                  <div className="back-button" id="back-btn">
                     <img alt = "" src="assets/back_arrow.svg" width="25px" height="45px"/>
                     Back
                  </div>
                  <div id="progress-bar-container">
                     <div className="progress">
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                     </div>
                  </div>
               </div>
               </div>
               </div>
               {/* ///////////////  END OF STEP 4//////////// */}


               {/* ////////////////// STEP 5 ///////////////////*/}
               <div className="main-container card">
                  <div className="row">
                     <div className="col-md-7">
                        <div id="questions-container">
                           <div>
                              { sectionQuestions1_5 && sectionQuestions1_5.length>0? sectionQuestions1_5.map((List, index)=>(
                              <div>
                                 <div className="card questions-card" style={{marginBottom:'0.25rem'}}>
                                    <div className="row">
                                       <div className="col-sm-12 col-md-12">
                                          <div className="question-div" >{List.QuestionText}</div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="card-body"  style={{paddingLeft:'0.5rem',  paddingBottom:'0'}}>
                                 <div className="row">
                                    {List.optionsDetails  &&  List.optionsDetails.length > 0 ? List.optionsDetails.map((optionsList, optionIndex) => (
                                    <div className="col-md-12 col-lg-6">
                                       <div className="form-check">
                                          <input type="radio"  id = {String(List.QuestionID+String(optionIndex))} className="form-check-input" name={"optradio5".concat(index)}   value=  {String(optionsList.OptionScoreValue)}  onChange={e => this.handleValueChanges(sectionQuestions1_5,List.optionsDetails,List.optionsDetails.length, optionIndex, e, index, List.QuestionTypeCode)}/>
                                          <label className="form-check-label" for={String(List.QuestionID+String(optionIndex))}>   
                                          {optionsList.OptionText}
                                          </label>
                                       </div>
                                    </div>
                                    )):
                                    <p> No options found.</p>
                                    }
                                 </div>
                              </div>
                           </div>
                           )):
                           <p> No question found.</p>
                           }
                        </div>
                     </div>
                  </div>
                  <div className="col-md-5">
                     <div className="card right-side-card" style={{padding: '2.5rem 2rem'}}>
                     <img alt = "" src="assets/message.svg" width="25px" height="25px" />
                     <div className="right-card-text"  style={{marginTop:'0.5rem'}}>
                        {  sectionQuestions1_5.slice(0, 1).map((List, counting)=>(
                        <div  style={{fontSize:'14px'}}> 
                           {List.SuggestionValue}
                        </div>
                        ))}
                     </div>
                  </div>
                  <button type="submit" className="btn next-btn" id="submit-button">Next</button>
                  <div className="back-button" id="back-btn">
                     <img alt = "" src="assets/back_arrow.svg" width="25px" height="45px"/>
                     Back
                  </div>
                  <div id="progress-bar-container">
                     <div className="progress">
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                     </div>
                  </div>
               </div>
               </div>
               </div>
            {/* ///////////////  END OF STEP 5//////////// */}

               {/* ////////////////// STEP 6 ///////////////////*/}
               <div className="main-container card">
                  <div className="row">
                     <div className="col-md-7">
                        <div id="questions-container">
                           <div>
                              { sectionQuestions1_6 && sectionQuestions1_6.length>0? sectionQuestions1_6.map((List, index)=>(
                              <div>
                                 <div className="card questions-card" style={{marginBottom:'0.25rem'}}>
                                    <div className="row">
                                       <div className="col-sm-12 col-md-12">
                                          <div className="question-div" >{List.QuestionText}</div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="card-body"  style={{paddingLeft:'0.5rem',  paddingBottom:'0'}}>
                                 <div className="row">
                                    {List.optionsDetails  &&  List.optionsDetails.length > 0 ? List.optionsDetails.map((optionsList, optionIndex) => (
                                    <div className="ps-options-wrapper">
                                       <div className="col-md-12 col-lg-12">
                                          <div className="form-check">
                                             <input type="radio" id = {String(List.QuestionID+String(optionIndex))} className="form-check-input" name={"optradio6".concat(index)}   value=  {String(optionsList.OptionScoreValue)}  onChange={e => this.handleValueChanges(sectionQuestions1_6,List.optionsDetails,List.optionsDetails.length, optionIndex, e, index, List.QuestionTypeCode)}/>
                                             <label className="form-check-label" for={String(List.QuestionID+String(optionIndex))}>   
                                             {optionsList.OptionText}
                                             </label>
                                          </div>
                                       </div>
                                    </div>
                                    )):
                                    <p> No options found.</p>
                                    }
                                 </div>
                              </div>
                           </div>
                           )):
                           <p> No question found.</p>
                           }
                        </div>
                     </div>
                  </div>
                  <div className="col-md-5">
                     <div className="card right-side-card" style={{padding: '2.5rem 2rem'}}>
                     <img alt = "" src="assets/message.svg" width="25px" height="25px" />
                     <div className="right-card-text"  style={{marginTop:'0.5rem'}}>
                        {  sectionQuestions1_6.slice(0, 1).map((List, counting)=>(
                        <div  style={{fontSize:'14px'}}> 
                           {List.SuggestionValue}
                        </div>
                        ))}
                     </div>
                  </div>
                  <button type="submit" className="btn next-btn" id="submit-button">Next</button>
                  <div className="back-button" id="back-btn">
                     <img alt = "" src="assets/back_arrow.svg" width="25px" height="45px"/>
                     Back
                  </div>
                  <div id="progress-bar-container">
                     <div className="progress">
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                     </div>
                  </div>
               </div>
               </div>
               </div>
               {/* ///////////////  END OF STEP 6//////////// */}


               {/* ////////////////// STEP 7  ///////////////////*/}
               <div className="main-container card">
                  <div className="row">
                     <div className="col-md-7">
                        <div id="questions-container">
                           <div>
                              { sectionQuestions1_7 && sectionQuestions1_7.length>0? sectionQuestions1_7.map((List, index)=>(
                              <div>
                                 <div className="card questions-card" style={{marginBottom:'0.25rem'}}>
                                    <div className="row">
                                       <div className="col-sm-12 col-md-12">
                                          <div className="question-div" >{List.QuestionText}</div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="card-body"  style={{paddingLeft:'0.5rem',  paddingBottom:'0'}}>
                                 <div className="row">
                                    {List.optionsDetails  &&  List.optionsDetails.length > 0 ? List.optionsDetails.map((optionsList, optionIndex) => (
                                    <div className="ps-options-wrapper">
                                       <div className="col-md-12 col-lg-12">
                                          <div className="form-check">
                                             <input type="radio" id = {String(List.QuestionID+String(optionIndex))} className="form-check-input" name={"optradio7".concat(index)}   value=  {String(optionsList.OptionScoreValue)}  onChange={e => this.handleValueChanges(sectionQuestions1_7,List.optionsDetails,List.optionsDetails.length, optionIndex, e, index, List.QuestionTypeCode)}/>
                                             <label className="form-check-label" for={String(List.QuestionID+String(optionIndex))}>   
                                             {optionsList.OptionText}
                                             </label>
                                          </div>
                                       </div>
                                    </div>
                                    )):
                                    <p> No options found.</p>
                                    }
                                 </div>
                              </div>
                           </div>
                           )):
                           <p> No question found.</p>
                           }
                        </div>
                     </div>
                  </div>
                  <div className="col-md-5">
                     <div className="card right-side-card" style={{padding: '2.5rem 2rem'}}>
                     <img alt = "" src="assets/message.svg" width="25px" height="25px" />
                     <div className="right-card-text"  style={{marginTop:'0.5rem'}}>
                        { sectionQuestions1_7.slice(0, 1).map((List, counting)=>(
                        <div  style={{fontSize:'14px'}}> 
                           {List.SuggestionValue}
                        </div>
                        ))}
                     </div>
                  </div>
                  <button type="submit" className="btn next-btn" id="submit-button">Next</button>
                  <div className="back-button" id="back-btn">
                     <img alt = "" src="assets/back_arrow.svg" width="25px" height="45px"/>
                     Back
                  </div>
                  <div id="progress-bar-container">
                     <div className="progress">
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                     </div>
                  </div>
               </div>
               </div>
               </div>
            {/* ///////////////  END OF STEP 7//////////// */}


            {/* ////////////////// STEP 8  ///////////////////*/}
            <div className="main-container card">
                  <div className="row">
                     <div className="col-md-7">
                        <div id="questions-container">
                           <div>
                              { sectionQuestions1_8 && sectionQuestions1_8.length>0? sectionQuestions1_8.map((List, index)=>(
                              <div>
                                 <div className="card questions-card" style={{marginBottom:'0.25rem'}}>
                                    <div className="row">
                                       <div className="col-sm-12 col-md-12">
                                          <div className="question-div" >{List.QuestionText}</div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="card-body"  style={{paddingLeft:'0.5rem',  paddingBottom:'0'}}>
                                 <div className="row">
                                    {List.optionsDetails  &&  List.optionsDetails.length > 0 ? List.optionsDetails.map((optionsList, optionIndex) => (
                                    <div className="ps-options-wrapper">
                                       <div className="col-md-12 col-lg-12">
                                          <div className="form-check">
                                             <input type="radio" id = {String(List.QuestionID+String(optionIndex))} className="form-check-input" name={"optradio8".concat(index)}   value=  {String(optionsList.OptionScoreValue)}  onChange={e => this.handleValueChanges(sectionQuestions1_8,List.optionsDetails,List.optionsDetails.length, optionIndex, e, index, List.QuestionTypeCode)}/>
                                             <label className="form-check-label" for={String(List.QuestionID+String(optionIndex))}>   
                                             {optionsList.OptionText}
                                             </label>
                                          </div>
                                       </div>
                                    </div>
                                    )):
                                    <p> No options found.</p>
                                    }
                                 </div>
                              </div>
                           </div>
                           )):
                           <p> No question found.</p>
                           }
                        </div>
                     </div>
                  </div>
                  <div className="col-md-5">
                     <div className="card right-side-card" style={{padding: '2.5rem 2rem'}}>
                     <img alt = "" src="assets/message.svg" width="25px" height="25px" />
                     <div className="right-card-text"  style={{marginTop:'0.5rem'}}>
                        { sectionQuestions1_8.slice(0, 1).map((List, counting)=>(
                        <div  style={{fontSize:'14px'}}> 
                           {List.SuggestionValue}
                        </div>
                        ))}
                     </div>
                  </div>
                  <button type="submit" className="btn next-btn" id="submit-button">Next</button>
                  <div className="back-button" id="back-btn">
                     <img alt = "" src="assets/back_arrow.svg" width="25px" height="45px"/>
                     Back
                  </div>
                  <div id="progress-bar-container">
                     <div className="progress">
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar"></div>
                        <div className="progress-bar"></div>
                     </div>
                  </div>
               </div>
               </div>
               </div>
            {/* ///////////////  END OF STEP 8//////////// */}

               {/* ///////////////  END OF STEP 9//////////// */}
               <div className="main-container card">
                  <div className="row">
                     <div className="col-md-7">
                        <div id="questions-container">
                           <div>
                              { sectionQuestions1_9 && sectionQuestions1_9.length>0? sectionQuestions1_9.map((List, index)=>(
                              <div>
                                 <div className="card questions-card" style={{marginBottom:'0.25rem'}}>
                                    <div className="row">
                                       <div className="col-sm-12 col-md-12">
                                          <div className="question-div" >{List.QuestionText}</div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="card-body"  style={{paddingLeft:'0.5rem',  paddingBottom:'0'}}>
                                 <div className="row">
                                    {List.optionsDetails  &&  List.optionsDetails.length > 0 ? List.optionsDetails.map((optionsList, optionIndex) => (
                                    <div className="col-md-12 col-lg-12">
                                       <div className="ps-options-wrapper">
                                          <div className="form-check">
                                             <input type="radio" id = {String(List.QuestionID+String(optionIndex))} className="form-check-input" name={"optradio9".concat(index)}   value=  {String(optionsList.OptionScoreValue)}  onChange={e => this.handleValueChanges(sectionQuestions1_9,List.optionsDetails,List.optionsDetails.length, optionIndex, e, index, List.QuestionTypeCode)}/>
                                             <label className="form-check-label" for={String(List.QuestionID+String(optionIndex))} >   
                                             {optionsList.OptionText}
                                             </label>
                                          </div>
                                       </div>
                                    </div>
                                    )):
                                    <p> No options found.</p>
                                    }
                                 </div>
                              </div>
                           </div>
                           )):
                           <p> No question found.</p>
                           }
                        </div>
                     </div>
                  </div>
                  <div className="col-md-5">
                     <div className="card right-side-card" style={{padding: '2.5rem 2rem'}}>
                     <img alt = "" src="assets/message.svg" width="25px" height="25px" />
                     <div className="right-card-text"  style={{marginTop:'0.5rem'}}>
                        {
                        sectionQuestions1_9.slice(0, 1).map((List, counting)=>(
                        <div  style={{fontSize:'14px'}}> 
                           <img alt = "" src={List.illustration} width="100%"/>
                        </div>
                        ))}
                     </div>
                  </div>
                  <button type="submit" className="btn next-btn" id="submit-button">Next</button>
                  <div className="back-button" id="back-btn">
                     <img alt = "" src="assets/back_arrow.svg" width="25px" height="45px"/>
                     Back
                  </div>
                  <div id="progress-bar-container">
                     <div className="progress">
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar step-done"></div>
                        <div className="progress-bar"></div>
                     </div>
                  </div>
               </div>
               </div>
               </div> 
               {/* ///////////////  END OF STEP 9//////////// */}

               {/* /////////////// STEP 10//////////// */}
          


               <div className="main-container card risk-range-wrapper">
                  <div className="row">
                     <div className="col-md-12">
                        <div className="range-specifier-container">
                           <div className="line-container">
                              <span style={{marginRight:"1rem"}}>Lower Expected Return & Low Risk</span>
                              <span className="line arrow-left"></span>
                              <span className="line arrow-right"></span>
                              <span style={{marginRight:"1rem"}}>Higher Expected Return & High Risk</span>
                           </div>
                        </div>
                        <div className="preference-wrapper">
                           <div className="preference-title card-title">
                              Based on the Principal’s feelings about risk and potential returns, what is your
                              goal?
                           </div>
                           <br/>
                           <div className="preference-slider">
                              <div className="row" style={{marginLeft:'100px'}}>
                                 <Box  >
                                    <Slider
                                       aria-label="Custom Values"
                                       defaultValue={0}
                                       value={SelectedCapitalSafety}
                                       step={5}
                                       min={5}
                                       max={20}
                                       valueLabelDisplay="off"
                                       marks={sectionQuestions2_1_Sliders[0]}
                                       onChange={e =>
                                    this.onChangeSelectedCapitalSafety(sectionQuestions2_1, e, sectionQuestions2_1_Sliders[0])}
                                    sx={{
                                    width: 1000,
                                    color: '#67707D',
                                    }}
                                    />
                                 </Box>
                              </div>
                           </div>
                        </div>
                        <div className="preference-wrapper">
                           <div className="preference-title card-title">
                              Which of the following statements best describes the Principal’s overall approach to
                              investing as a means of achieving your goals?
                           </div>
                           <div className="preference-slider">
                              <div className="row" style={{marginLeft:'100px'}}>
                                 <Box  >
                                    <Slider
                                       aria-label="Custom Values"
                                       defaultValue={0}
                                       value={SelectedRiskPreference}
                                       step={5}
                                       min={5}
                                       max={25}
                                       valueLabelDisplay="off"
                                       marks={sectionQuestions2_1_Sliders[1]}
                                       onChange={e =>
                                    this.onChangeSelectedRiskPreference(sectionQuestions2_1, e, sectionQuestions2_1_Sliders[1])}
                                    sx={{
                                    width: 1000,
                                    color: '#67707D',
                                    }}
                                    />
                                 </Box>
                              </div>
                           </div>
                        </div>
                        <div className="preference-wrapper">
                           <div className="preference-title card-title">
                              Which of the following investments would the Principal choice to add to your investment
                              portfolio?
                           </div>
                           <div className="preference-slider">
                              <div className="row" style={{marginLeft:'100px'}}>
                                 <Box  >
                                    <Slider
                                       aria-label="Custom Values"
                                       defaultValue={0}
                                       value={SelectedProductPreference}
                                       step={5}
                                       min={5}
                                       max={20}
                                       valueLabelDisplay="off"
                                       marks={sectionQuestions2_1_Sliders[2]}
                                       onChange={e =>
                                    this.onChangeSelectedProductPreference(sectionQuestions2_1, e, sectionQuestions2_1_Sliders[2])}
                                    sx={{
                                    width: 1000,
                                    color: '#67707D',
                                    }}
                                    />
                                 </Box>
                              </div>
                           </div>
                        </div>
                        <div className="row" style={{marginTop:"0.75rem"}}>
                           <div className="col-md-4">
                              <div style={{marginTop:"1rem"}}>
                                 <div className="progress">
                                    <div className="progress-bar step-done"></div>
                                    <div className="progress-bar step-done"></div>
                                    <div className="progress-bar step-done"></div>
                                    <div className="progress-bar step-done"></div>
                                    <div className="progress-bar step-done"></div>
                                    <div className="progress-bar step-done"></div>
                                    <div className="progress-bar step-done"></div>
                                    <div className="progress-bar step-done"></div>
                                    <div className="progress-bar step-done"></div>
                                    <div className="progress-bar step-done"></div>
                                 </div>
                              </div>
                           </div>
                           <div  className="slider-button-div col-md-8">
                              <div className="row">
                                 <div className="col-md-5">
                                    <div className="back-button slider-back-btn" id="back-btn" style={{marginTop:"-5px"}}>
                                       <img alt = "" src="assets/back_arrow.svg" width="25px" height="45px"/>
                                       Back
                                    </div>
                                 </div>
                                 <div className="col-md-7">
                                    


                    <button type="submit" className="btn next-btn slider-next-btn" 
                    
                    id= "buttonForm" onClick={e => this.submitData()} style={{marginTop:"0"}}
                    disabled={!this.state.portfolioSizeCheck}
                  //   disabled
                    >Next</button>
                


                                    <br/>
                                    <p style={{color:'red'}}>{this.state.dataFillingMessageError}</p>
                                 <p style={{color:'success'}}>{this.state.dataFillingMessageSuccess}</p>
                                 </div>

                                 
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               {/* /////////////// End Of STEP 10//////////// */}

{/* ////////////////////////////////////////////////////////////// */}

     

              {/* //////////////////////////////////////////////////// */}

              

               <div className="main-container card risk-range-wrapper risk-assessment-tabs">


               <div className="">
              <div className="row">
                <div className="col-xs-12" style={{width:'100%'}}>
                  <nav>
                    <div className="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                      <a className="nav-item nav-link active"  id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true">Recommended Model</a>
                      <a hidden className="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false">Graphs</a>
                      <a className="nav-item nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-contact" role="tab" aria-controls="nav-contact" aria-selected="false">Customize</a>
                      
                    </div>
                  </nav>
                  <div className="tab-content" id="nav-tabContent">
                    <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                   
            <div id="recommendation-tabtoPDF">
             <div className="row">
            
                <div className="col-md-12 col-lg-6 risk-assessment-div">
                
                    <div id="risk-assessment-heading">Preliminary Risk Assessment</div>
                    <div className="risk-assessment-level">
                    {CalculatedModelType}
                    </div>
                   
                    <div className="row risk-calculation-div">

                        <div className="col-md-12 justify-content-end"  style={{paddingRight:'0'}}>
                            <div className="risk-calculation-btn modal-back-btn back-button">
      Recalculate Risk
   </div>
                          </div> 
                   </div>
                    
                </div>
               
               
                       <div className="col-md-12 col-lg-6 donut-chart-wrapper">
                <Chart
   width={'500px'}
   height={'400px'}
   chartType="PieChart"
   loader={
   <div>Loading Chart...</div>
   }
   data={PreliminaryRiskAssessmentChart}
   options={pieOptions}
   rootProps={{ 'data-testid': '3' }}
   />
                </div>  
               
               
             </div>

             <div className="table-responsive">
                <table className="table table-borderless asset-table">
                    <thead>
                      <tr>
                        <th>Asset Class</th>
                        <th>{CalculatedModelType}</th>
                      </tr>
                    </thead>
                    <tbody>
                      
                      {/* /////////////////////////// */}
                      { PreliminaryRiskAssessmentChart.slice(1, PreliminaryRiskAssessmentChart.length).map((List, counting)=>(
                        PreliminaryRiskAssessmentChart[counting+1][1]!=0?
                        (
                         <tr>
                         <td>{PreliminaryRiskAssessmentChart[counting+1][0]}</td>
                         <td>{((PreliminaryRiskAssessmentChart[counting+1][1]).toString()).substr(0,4)}%</td>
                       </tr>
                         ) : ""
                        ))}
                    </tbody>
                  </table>
               </div> 


             <div className="card risk-assessment-table-wrapper">
                <div className="table-responsive">
                  <table className="table portfolio-table table-borderless">
                      <thead>
                        <tr>
                          <th>Portfolio</th>
                          <th>Return</th>
                          <th>Yield</th>
                          <th>StdDev</th>
                          <th>Sharpe Ratio</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{CalculatedModelType}</td>
                          <td>{parseFloat(CalculatedModelTypeValues[0]).toFixed(1)}%</td>
                          <td>{parseFloat(CalculatedModelTypeValues[1]).toFixed(1)}%</td>
                          <td>{parseFloat(CalculatedModelTypeValues[2]).toFixed(1)}%</td>
                          <td>{parseFloat(CalculatedModelTypeValues[3]).toFixed(1)}</td>
                        </tr>
                      </tbody>
                    </table>
                 </div>  
          </div>
      

          <div className="growth-chart">
          <Chart
  chartType="AreaChart"
  data={_100DollarChart}
  width="100%"
  height="400px"
  legendToggle
/>
          </div>
         

          
          </div>

          <div className="export-buttons-div">
            <a className="share-btn"  onClick={e => this.printDocument('recommendation-tabtoPDF')}>
               Export To PDF
               
                
            </a>
            &nbsp;
            <div className="share-btn">
                Send via Email
            </div>
          </div>
          
                    </div>
                    
                    <div className="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                    
                  <div className="annual-charts-wrapper">
                    <div className="row">
                       <div className="col-md-6">
                             <img alt = "" src="assets/annual_growth_bar_chart.jpg" className="charts-images"/>
                       </div>
                       <div className="col-md-6">
                        <img alt = "" src="assets/annual_growth_pie_chart.jpg" className="charts-images"/>
                      </div>
                    </div>

                    <div className="row" style={{marginTop:'3rem'}}>
                      <div className="col-md-6">
                            <img alt = "" src="assets/annual_growth_point_chart.svg" className="charts-images"/>
                      </div>
                      <div className="col-md-6">
                       <img alt = "" src="assets/scatter_chart.jpg" className="charts-images"/>
                     </div>
                   </div>
                  </div>
         
                    </div>


                    {/* //////////// ///////////////////// Custom Models Tab/////////////////////////////// */}
                   

                    <div className="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                    
         <div id="customized-tabtoPDF">
           <div className="row customized-radio-wrapper">
             <div className="col-sm-12 col-md-3"></div>
             <div className="col-sm-12 col-md-3">Explore more models:</div>
                
            
            { _ALL_Models.map((List, counting)=>(  
            <div className="col-sm-12 col-md-2 float-right">
               
              <input type="radio" id={"otherModel"+counting}  className="form-check-input customized-radio-input"  name="custommodelradio" 
              value={ _ALL_Models[counting]}
              onChange={e => this.handleOtherModelTypeChanges(_ALL_Models[counting], e)}
              
              />
              &nbsp;
              <label for={"otherModel"+counting} className="form-check-label">{ _ALL_Models[counting]}</label>
                 </div>
                
                ))}
            
            
            
           </div>
          <div className="table-responsive">
            <table className="table table-borderless asset-table customized-table">
                <thead>
                  <tr>
                    <th>Asset Class</th>
                    <th>{CalculatedModelType}</th>
                    <th></th>
                    <th>Customized {Custom_Model}</th>
                  </tr>
                </thead>

                <tbody>
              

{ Custom_ModelArray.map((List, counting)=>(
                 <tr>
                 <td>{PreliminaryRiskAssessmentChart[counting+1][0]}</td>
                 <td>{((PreliminaryRiskAssessmentChart[counting+1][1]).toString()).substr(0,4)}%</td>
                 <td></td>
                 <td id = {String("customizedTDValue"+String(counting))}> 
                 <input className="edit-input" onChange={e => this.handleCustomClassChanges(counting,PreliminaryRiskAssessmentChart[counting+1][0],e)} name={PreliminaryRiskAssessmentChart[counting+1][0]} value={((Custom_ModelArray[counting].assetClassValue).toString()).substr(0,4)} />% <img alt = "Edit" src="assets/edit_icon.svg" className="edit-icon"/>
                 </td>
                
               </tr>
                ))} 
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                     <p style={{color:'red'}}>{this.state.reloadbtn==false? "Sum of weights should be 100":""}</p>
                      <a disabled={this.state.reloadbtn==false? "disabled":""}  onClick={e => this.reloadData(e)} className="reload-btn">
                        <img alt = "Reload" src="assets/reload_icon.svg"/>
                        Reload
                    </a>
                    </td>
                  </tr>

                  
                </tbody>
              </table>
           </div>

           <div className="col-md-12 col-lg-12">
              <div className="row">

              <div className="col-md-6 col-lg-6">
              <h3 style={{textAlign:'center'}}>{CalculatedModelType}</h3>
                               <Chart
   width={'95%'}
   height={'95%'}
   chartType="PieChart"
   loader={
   <div>Loading Chart</div>
   }
   data={PreliminaryRiskAssessmentChart}
   options={pieOptions}
   rootProps={{ 'data-testid': '3' }}
   />

   </div>

   <div className="col-md-6 col-lg-6">
      <h3 style={{textAlign:'center'}}>Customized {Custom_Model}</h3>
                
                               <Chart
                                 width={'95%'}
                                 height={'95%'}
                                 chartType="PieChart"
                                 loader={
                                 <div>Loading Chart</div>
                                 }
                                 data={CustomModelChart}
                                 options={pieOptions}
                                 rootProps={{ 'data-testid': '3' }}
                                 />
                   </div>

                  </div>
           </div>
           
           <div className="card risk-assessment-table-wrapper">
            <div className="table-responsive">
              <table className="table portfolio-table table-borderless">
                  <thead>
                    <tr>
                      <th>Portfolio</th>
                      <th>Return</th>
                      <th>Yield</th>
                      <th>StdDev</th>
                      <th>Sharpe Ratio</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                          <td>{CalculatedModelType}</td>
                          <td>{parseFloat(CalculatedModelTypeValues[0]).toFixed(1)}%</td>
                          <td>{parseFloat(CalculatedModelTypeValues[1]).toFixed(1)}%</td>
                          <td>{parseFloat(CalculatedModelTypeValues[2]).toFixed(1)}%</td>
                          <td>{parseFloat(CalculatedModelTypeValues[3]).toFixed(1)}</td>
                    </tr>
                    
                    { Custom_ModelArray.slice(0,1).map((List, counting)=>(
                 <tr>
                <td> Customized {Custom_Model}</td>
                
                      
                      <td id = {String("modelValues"+String(0))}> {parseFloat(this.state.Custom_ModelArray[0].returnValue).toFixed(1)}% </td>
                      <td id = {String("modelValues"+String(1))}> {parseFloat(this.state.Custom_ModelArray[0].yield).toFixed(1)}% </td>
                      <td id = {String("modelValues"+String(2))}> {parseFloat(this.state.Custom_ModelArray[0].standardDeviation).toFixed(1)}% </td>
                      <td id = {String("modelValues"+String(3))}> {parseFloat(this.state.Custom_ModelArray[0].sharpeRatio).toFixed(1)}% </td> 
                
               </tr>
                ))}



                  </tbody>
                </table>
             </div>  
      </div>

     {/*
      <div className="growth-chart">
        <img alt = "Chart" src="assets/asset_recommendation_chart.svg"/>
      </div>
                    */}

      <div className="export-buttons-div">
        <a className="share-btn" onClick={e => this.printDocument('customized-tabtoPDF')}>

        Export to PDF
                    
          
      </a>
        &nbsp;
        <div className="share-btn">
            Send via email
        </div>
      </div>
      </div>

         
                    </div>
                   
                  </div>
                
                </div>
              </div>
        </div>
      


    
     


    <div className="row">

       {/*  */}
       <div hidden className="btn modal-back-btn back-button" id="go-back-slider">
                           <img alt = "back" src="assets/back_arrow.svg" width="25px" height="45px"/>
                           Back
            </div>

            <Modal id="biodata-modal" size="md" dialogClassName="modal-90w" show={this.state.showModal} onHide={this.closeModal.bind(this)}>
               <Modal.Header>
                  <Modal.Title style={{width:'95%'}}>
                     <div className="modal-heading">Enter Bio Data</div>
                  </Modal.Title>
                  <a style={{width:'5%'}} onClick={this.closeModal.bind(this)}><i className="fa fa-times"></i></a>
               </Modal.Header>
               <Modal.Body >
                  <div>
                     <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                           <div className="modal-body">
                              <div className="row">
                                 <div className="col-md-6 ">
                                    <div className="form-group">
                                       <label>First Name*</label>
                                       <input type="text" className="form-control" value={this.state.fname}  onChange={this.onChangeFirstName} id="firstName" placeholder="Enter your first name" />
                                    </div>
                                 </div>
                                 <div className="col-md-6">
                                    <div className="form-group">
                                       <label>Last Name</label>
                                       <input type="text" className="form-control" value={this.state.lname}  onChange={this.onChangeLastName} id="lastName" placeholder="Enter your last name" />
                                    </div>
                                 </div>
                              </div>
                          
                              <div className="row">
                                 <div className="col-md-6 ">
                                    <div className="form-group">
                                       <label>Contact Number*</label>
                                       <input type="text" className="form-control" id="inputEmail" value={this.state.contact}   onChange={this.onChangeContact} placeholder="Enter your contact number" />
                                    </div>
                                 </div>
                                 <div className="col-md-6 ">
                                    <div className="form-group">
                                       <label>Email Address*</label>
                                       <input type="email" onChange={this.onChangeEmail} value={this.state.email} className="form-control" id="inputEmail" placeholder="Enter your email address" />
                                    </div>
                                 </div>
                              </div>
                              {!this.state.submitted ? (
                              <div>
                                 <div className="row">
                                    <div className="col-md-1">
                                    </div>
                                    <div className="col-md-10">
                                       <div className="form-group">
                                          <button type="submit" onClick={this.actionModalSubmit.bind(this)} className="btn modal-next-btn" id="submit-button">Submit</button>
                                       </div>
                                    </div>
                                    <div className="col-md-1">
                                    </div>
                                 </div>
                                 <div className="row">
                                    <div className="col-md-1">
                                    </div>
                                    <div className="col-md-10">
                                       <div className="form-group">
                                          <button  onClick={this.closeModalAndGoBack.bind(this)} className="btn modal-back-btn back-button">
                                          <img alt = "back" src="assets/back_arrow.svg" width="25px" height="25px"/>
                                          Back
                                          </button>
                                       </div>
                                    </div>
                                    <div className="col-md-1">
                                    </div>
                                 </div>
                              </div>
                              ) :  (     
                              <div className="row">
                                 <div className="col-md-1">
                                 </div>
                                 <div className="col-md-10">
                                    <div className="form-group">
                                       <button type="submit" onClick={this.closeModal.bind(this)} className="btn modal-next-btn" id="submit-button">Close</button>
                                    </div>
                                 </div>
                                 <div className="col-md-1">
                                 </div>
                              </div>
                              )}
                              <p id="bioerrorMessage" style={{color:"red",width: '100% !important',textAlign:'center'}}></p>
                              <p  id="biosuccessMessage" style={{color:"green",width: '100% !important',textAlign:'center'}}></p>
                           </div>
                        </div>
                     </div>
                  </div>
               </Modal.Body>
            </Modal>
       {/*  */}
        <div className="col-md-12">
        {/* huda */}
        
         

        </div>
    </div>

</div>

{/* ///////////////////// */}


            </div>
         </section>
         </div> 
      </div>
  
   );
}
}
